import {
  Component,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CdkTrapFocus } from '@angular/cdk/a11y';
import { SuiButtonComponent } from '@stride-ui/components';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'tnq-fullscreen-dialog',
  templateUrl: './fullscreen-dialog.component.html',
  styleUrls: ['./fullscreen-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CdkTrapFocus, SuiButtonComponent, TranslateModule],
})
export class FullscreenDialogComponent {
  readonly title = input.required<string>();
  readonly subtitle = input.required<string>();

  readonly closed = output();

  dismiss() {
    this.closed.emit();
  }
}
